import Service from "../../../Services/index";
import moment from "moment";

const employee = {
    namespaced: true,
    state: {
        employeeList: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        searchSalary: {
            position: "",
            department: [],
            transaction_type: "",
            position_id: null,
            transaction_type_id: null,
            employee: [],
            active: ''
        },
        search: {
            passport: "",
            department: "",
            status: "",
            shift: "",
            insurance_card_number: '',
            myanmar_list: '',
            employee: '',
            active: "",
        },
        quarantor2: {
            //citizen_card
            employee_quarantee_id: '',
            employee_quarantee: null,
            citizen_id: "",
            issue_at: "",
            expire_date: "",

            //address
            house_no: "",
            village_no: "",
            district: "",
            district_id: null,
            sub_district: "",
            sub_district_id: null,
            postal_code: "",
            road: "",
            province: "",
            province_id: null,
            email: "",

            name: "",
            relationship: "",
            company_address: "",
            position: "",
            phone: "",
            career: ""
        },
        quarantor1: {
            //citizen_card
            employee_quarantee_id: '',
            employee_quarantee: null,
            citizen_id: "",
            issue_at: "",
            expire_date: "",

            //address
            house_no: "",
            village_no: "",
            district: "",
            district_id: null,
            sub_district: "",
            sub_district_id: null,
            postal_code: "",
            road: "",
            province: "",
            province_id: null,
            email: "",

            name: "",
            relationship: "",
            company_address: "",
            position: "",
            phone: "",
            career: ""
        },
        employeeForm: {
            id: '',
            employee_no: '',
            employee_card: '',
            prefix: '',
            sex_id: '',
            first_name: '',
            last_name: '',
            english_name: '',
            marital_status: null,
            tax_number: '',
            birthday: null,
            age: null,
            status_leave: null,
            user_id: null,
            file_upload: '',
            is_approve: '',
            start_work_time: null,
            end_work_time: null,
            address: {
                house_no: '',
                village_no: '',
                road: '',
                district: null,
                district_id: null,
                sub_district: null,
                sub_district_id: null,
                province: null,
                province_id: null,
                postal_code: null,
                email: '',
                phone1: '',
                phone2: '',
            },
            citizen: {
                citizen_id: null,
                citizen_id_history: null,
                issue_at: null,
                expire_date: null
            },
            nationality: {
                nationality: null,
                nationality_name: null,
                group_employee: null,
                passport_type_id: null
            },
            work_status: {
                active_status_id: 1,
                start_work_date: null,
                resign_date: null,
                reason: null,
                reason_txt: null,
                visa_date: "",
                visa_expire_date: "",
                certificate_date: "",
                certificate_expire_date: "",
                myanmar_list: "",
            },
            occupation: {
                position_id: null,
                department_id: null,
                employee_type: null,
                shift: null,
                work_schedule_id: null,
                rate_bonus_group: null,
                rate_bonus_group2: null,
                rate_bonus_group3: null,
                rate_bonus_group4: null,
                rate_bonus_group5: null,
                rate_bonus_group_id: null,
                rate_bonus_group_id2: null,
                rate_bonus_group_id3: null,
                rate_bonus_group_id4: null,
                rate_bonus_group_id5: null,
                rate_sale_type: null,
            },
            salary: {
                salary: null,
                update_date: null,
                salary_per_day: null,
                paid_period: null
            },
            transaction: {
                transaction_type_id: null,
                bank_name: null,
                account_no: null,
                account_name: null
            },
            work_benefit: {
                work_start_date: null,
                accept_offer_date: null,
                salary_pay_date: null,
                benefit_type: null,
                benefit_amount: null,
                benefit_date: '',
            },
            leave_day: [],
            quarantee: {
                amount_total: null,
                paid: null,
                amount: null,
                paid_back: 0,
                reason: null,
                paid_back_date: '',
            },
            quarantor: [],
            image: [],
            leaving_day: [],
            tax: {
                income_total: null,
                cost_half: null,
                cost_private: null,
                cost_social_security: null,
                cost_other: null,
                total: '',
                total_tax: '',
                tax_per_month: '',
            },
            insurance: {
                status_pay_insurance: false,
                how_insurance_pay: null,
                date: '',
                insurance_card_number: '',
                name_title_id: null,
                hospital_id: null,
                hospital1: '',
                hospital2: '',
                hospital3: '',
                hospital_name: '',
                insurance_first_name: '',
                insurance_last_name: '',
            },
        },
        leaveDayAll: [],
        modal_salary_detail: [],
        activeStatus: null,
    },
    mutations: {
        GET_EMPLOYEE_LIST: (state, res) => {
            state.employeeList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_ACTIVE_STATUS: (state, status) => {
            state.activeStatus = status;
        },
        CLEAR_DATA: state => {
            state.leaveDayAll = [],
                state.quarantor2 = {
                    //citizen_card
                    citizen_id: "",
                    issue_at: "",
                    expire_date: "",

                    //address
                    house_no: "",
                    village_no: "",
                    district: "",
                    district_id: null,
                    sub_district: "",
                    sub_district_id: null,
                    postal_code: "",
                    road: "",
                    province: "",
                    province_id: null,
                    email: "",
                    phone1: '',
                    phone2: '',

                    name: "",
                    relationship: "",
                    company_address: "",
                    position: "",
                    phone: "",
                    career: ""
                };
            state.quarantor1 = {
                //citizen_card
                citizen_id: null,
                issue_at: "",
                expire_date: "",

                //address
                house_no: "",
                village_no: "",
                district: "",
                district_id: null,
                sub_district: "",
                sub_district_id: null,
                postal_code: "",
                road: "",
                province: "",
                province_id: null,
                email: "",
                phone1: '',
                phone2: '',

                name: "",
                relationship: "",
                company_address: "",
                position: "",
                phone: "",
                career: ""
            };
            state.employeeForm = {
                id: "",
                employee_no: "",
                employee_card: "",
                prefix: "",
                sex_id: "",
                first_name: "",
                last_name: "",
                english_name: "",
                marital_status: "",
                tax_number: "",
                birthday: "",
                status_leave: "",
                age: "",
                file_upload: "",
                is_approve: '',
                start_work_time: null,
                end_work_time: null,
                address: {
                    house_no: "",
                    village_no: "",
                    road: "",
                    district: "",
                    district_id: "",
                    sub_district: "",
                    sub_district_id: "",
                    province: "",
                    province_id: "",
                    postal_code: "",
                    email: "",
                    phone1: '',
                    phone2: '',
                },
                citizen: {
                    citizen_id: "",
                    issue_at: "",
                    expire_date: ""
                },
                nationality: {
                    nationality: "",
                    nationality_name: "",
                    group_employee: null,
                    passport_type_id: null
                },
                work_status: {
                    active_status_id: 1,
                    start_work_date: "",
                    resign_date: "",
                    reason: "",
                    reason_txt: "",
                    visa_date: "",
                    visa_expire_date: "",
                    certificate_date: "",
                    certificate_expire_date: "",
                    myanmar_list: "",
                },
                occupation: {
                    position_id: "",
                    department_id: "",
                    employee_type: "",
                    shift: "",
                    work_schedule_id: "",
                    rate_bonus_group: "",
                    rate_bonus_group2: "",
                    rate_bonus_group3: "",
                    rate_bonus_group4: "",
                    rate_bonus_group5: "",
                    rate_bonus_group_id: "",
                    rate_bonus_group_id2: "",
                    rate_bonus_group_id3: "",
                    rate_bonus_group_id4: "",
                    rate_bonus_group_id5: "",
                },
                salary: {
                    salary: "",
                    update_date: "",
                    salary_per_day: "",
                    paid_period: ""
                },
                transaction: {
                    transaction_type_id: "",
                    bank_name: "",
                    account_no: "",
                    account_name: ""
                },
                work_benefit: {
                    work_start_date: null,
                    accept_offer_date: null,
                    salary_pay_date: null,
                    benefit_type: null,
                    benefit_amount: null,
                    benefit_date: '',
                },
                leave_day: [],
                quarantee: {
                    amount_total: "",
                    paid: "",
                    amount: "",
                    paid_back: 0,
                    reason: "",
                    paid_back_date: '',
                },
                quarantor: [],
                image: [],
                leaving_day: [],
                tax: {
                    income_total: "",
                    cost_half: "",
                    cost_private: "",
                    cost_social_security: "",
                    cost_other: '',
                    total: '',
                    total_tax: '',
                    tax_per_month: '',
                },
                insurance: {
                    status_pay_insurance: false,
                    how_insurance_pay: null,
                    date: '',
                    insurance_card_number: '',
                    name_title_id: null,
                    hospital_id: null,
                    hospital1: '',
                    hospital2: '',
                    hospital3: '',
                    hospital_name: '',
                },
            }
        },
        GET_EMPLOYEE_BY_ID: (state, res) => {
            state.employeeForm = res;
            if (!res.tax) {
                state.employeeForm.tax = {
                    income_total: "",
                    cost_half: "",
                    cost_private: "",
                    cost_social_security: ""
                }
            }
            if (!res.insurance) {
                state.employeeForm.insurance = {
                    status_pay_insurance: null,
                    how_insurance_pay: null,
                    date: '',
                    insurance_card_number: '',
                    name_title_id: null,
                    hospital_id: null,
                    hospital1: '',
                    hospital2: '',
                    hospital3: '',
                    hospital_name: '',
                }
            }
            if (res.quarantor.length > 0) {
                if (res.quarantor.length > 1) {
                    state.quarantor2 = res.quarantor[1]
                }
                state.quarantor1 = res.quarantor[0]
            }
        },
        GET_LEAVEDAY_ALL: (state, res) => {
            state.leaveDayAll = res;
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                passport: "",
                department: "",
                status: "",
                shift: "",
                insurance_card_number: '',
                myanmar_list: '',
                employee: '',
                active: "",
            }
        },
        CLEAR_SALARY_SEARCH: (state) => {
            state.searchSalary = {
                position: "",
                department: [],
                transaction_type: "",
                position_id: null,
                transaction_type_id: null,
                employee: [],
                active: ''
            }
        },
        SET_MODAL_DETAIL: (state, res) => {
            state.modal_salary_detail = res
        },
        CLEAR_SALARY_MODAL: (state) => {
            state.modal_salary_detail = [];
        },
    },
    actions: {
        setEmployee({commit}, page = 1) {
            return Service.Employee.getEmployee(page).then(response => {
                commit("GET_EMPLOYEE_LIST", response);
            });
        },
        getEmployeeByID({commit}, id) {
            return Service.Employee.showEmployee(id).then(response => {
                commit("GET_EMPLOYEE_BY_ID", response);
            });
        },
        updateSalaryEmployee({commit}, data) {
            return Service.Employee.updateSalaryEmployee(data);
        },
        setEmployeeFilter({commit}, {page = 1, status = 1}) {
            commit("SET_ACTIVE_STATUS", status);
            return Service.Employee.filterEmployee(page, status)
                .then(response => {
                    commit("GET_EMPLOYEE_LIST", response);
                });
        },
        Payroll({commit}, data) {
            return Service.Employee.Payroll(data)
        },
        saveEmployee({commit, state}, {id, data}) {
            data.work_benefit.work_start_date = data.work_benefit.work_start_date ? moment(data.work_benefit.work_start_date).format('YYYY-MM-DD') : null;
            if (data.quarantor2)
                data.quarantor2.expire_date = data.quarantor2 && data.quarantor2.expire_date ? moment(data.quarantor2.expire_date).format('YYYY-MM-DD') : null;
            if (data.quarantor1)
                data.quarantor1.expire_date = data.quarantor1 && data.quarantor1.expire_date ? moment(data.quarantor1.expire_date).format('YYYY-MM-DD') : null;
            data.citizen.expire_date = data.citizen.expire_date ? moment(data.citizen.expire_date).format('YYYY-MM-DD') : null;
            data.work_status.start_work_date = data.work_status.start_work_date ? moment(data.work_status.start_work_date).format('YYYY-MM-DD') : null;
            data.work_status.resign_date = data.work_status.resign_date ? moment(data.work_status.resign_date).format('YYYY-MM-DD') : null;
            data.work_status.visa_date = data.work_status.visa_date ? moment(data.work_status.visa_date).format('YYYY-MM-DD') : null;
            data.work_status.visa_expire_date = data.work_status.visa_expire_date ? moment(data.work_status.visa_expire_date).format('YYYY-MM-DD') : null;
            data.work_status.certificate_date = data.work_status.certificate_date ? moment(data.work_status.certificate_date).format('YYYY-MM-DD') : null;
            data.work_status.certificate_expire_date = data.work_status.certificate_expire_date ? moment(data.work_status.certificate_expire_date).format('YYYY-MM-DD') : null;
            data.salary.update_date = data.salary.update_date ? moment(data.salary.update_date).format('YYYY-MM-DD') : null;
            data.work_benefit.work_start_date = data.work_benefit.work_start_date ? moment(data.work_benefit.work_start_date).format('YYYY-MM-DD') : null;
            data.work_benefit.accept_offer_date = data.work_benefit.accept_offer_date ? moment(data.work_benefit.accept_offer_date).format('YYYY-MM-DD') : null;
            data.work_benefit.salary_pay_date = data.work_benefit.salary_pay_date ? moment(data.work_benefit.salary_pay_date).format('YYYY-MM-DD') : null;
            data.work_benefit.benefit_date = data.work_benefit.benefit_date ? moment(data.work_benefit.benefit_date).format('YYYY-MM-DD') : null;
            data.quarantee.paid_back_date = data.quarantee.paid_back_date ? moment(data.quarantee.paid_back_date).format('YYYY-MM-DD') : null;
            data.insurance.date = data.insurance.date ? moment(data.insurance.date).format('YYYY-MM-DD') : null;
            data.birthday = data.birthday ? moment(data.birthday).format('YYYY-MM-DD') : null;
            if (data.address.district)
                data.address.district_id = data.address.district.id
            if (data.address.sub_district)
                data.address.sub_district_id = data.address.sub_district.id
            if (data.address.province)
                data.address.province_id = data.address.province.id
            if (!id) { //create
                return Service.Employee.createEmployee(data).then(response => {
                    if (state.employeeForm.file_upload) {
                        if (response && response.id) {
                            //upload file form
                            let formData = new FormData();
                            formData.append("file_upload", state.employeeForm.file_upload);
                            formData.append("id", response.id);
                            Service.Employee.uploadFilePDF(formData)
                        }
                    }
                    //console.log('CREATE SUCCESS')
                })
            } else { //update
                return Service.Employee.updateEmployee(id, data).then(response => {
                    if (state.employeeForm.file_upload) {
                        if (response && response.id) {
                            //upload file form
                            let formData = new FormData();
                            formData.append("file_upload", state.employeeForm.file_upload);
                            formData.append("id", response.id);
                            Service.Employee.uploadFilePDF(formData)
                        }
                    }
                    //console.log('UPDATE SUCCESS')
                })
            }
        },
        deleteEmployee({commit}, id) {
            return Service.Employee.deleteEmployee(id);
        },
        getEmployeeAll({commit}) {
            return Service.Employee.getEmployeeAll();
        },
        getEmployeeAll_data({commit}) {
            return Service.Employee.getEmployeeAll_data();
        },
        getTypeList({commit}) {
            return Service.Employee.getTypeList();
        },
        getTypeListIncome({commit}) {
            return Service.Employee.getTypeListIncome();
        },
        getEmployeeDataAll({commit}) {
            return Service.Employee.getEmployeeAll();
        },
        clearData({commit}) {
            commit("CLEAR_DATA")
        },
        setLeaveDayAll({commit}) {
            return Service.LeaveDay.getLeaveDayAll().then(response => {
                commit("GET_LEAVEDAY_ALL", response);
            });
        },
        search({commit}, data) {
            return Service.Employee.searchEmployee(data).then(res => {
                commit("GET_EMPLOYEE_LIST", res);
            })
        },
        searchPaymentSalary({commit}, data) {
            return Service.Employee.searchPaymentSalary(data).then(res => {
                commit("GET_EMPLOYEE_LIST", res);
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        clearSalarySearch({commit}) {
            commit("CLEAR_SALARY_SEARCH");
        },
        validatePassportNumber({commit}, data) {
            // //console.log(data);
            return Service.Employee.validatePassportNumber(data.citizen_id);
        },
        approveEmployee({commit}, data) {
            return Service.Employee.approveEmployee(data);
        },
        approveResignEmployee({commit}, data) {
            return Service.Employee.approveResignEmployee(data);
        },
        validateEmployeeNo({commit}, employee_no) {
            return Service.Employee.validateEmployeeNo(employee_no);
        },
        //slip salary
        previewSalaryPDF({commit}, data) {
            return Service.Employee.previewSalaryPDF(data);
        },
        exportSlipSalaryEmployee({commit}, data) {
            return Service.Employee.exportSlipSalaryEmployee(data);
        },
        exportExpireEmployee({commit}, data) {
            return Service.Employee.exportExpireEmployee(data);
        },
        addNation({commit}, data) {
            return Service.Employee.addNation(data);
        },
        deleteNation({commit}, data) {
            return Service.Employee.deleteNation(data);
        },
        updateSalary({commit}, data) {
            return Service.Employee.updateSalary(data).then(() => {
                commit('CLEAR_SALARY_MODAL')
            });
        },
        deleteSalary({commit}, id) {
            return Service.Employee.deleteSalary(id)
        },
        approveSalary({commit}, data) {
            return Service.Employee.approveSalary(data)
        },
        detailSalary({commit}, id) {
            return Service.Employee.detailSalary(id).then(res => {
                commit('SET_MODAL_DETAIL', res)
            });
        }
    }
};
export default employee;
